import { get, patch, post } from '..';
import { parseObjectToQueryString } from '../../utils/parser';

const getDrives = (query) => get(`/requests/drive${parseObjectToQueryString(query)}`);
// const getRides = (trip_id) => get(`/requests/trip/${trip_id}/rides`);
// const updateRidesDrive = (data) => patch(`/requests/rides/swap`, data);
const cancelDriver = (trip_id) => post(`/requests/trip/cancel/${trip_id}`);
const createDriverCancellationEstimate = (trip_id) => post(`/requests/trip/cancel/estimate/${trip_id}`);
const getRiderHistory = (rider_id) => get(`/requests/history/rider/${rider_id}`);
const getDriverHistory = (driver_id) => get(`/requests/history/driver/${driver_id}`);
const getTrips = (query) => get(`/requests/trip${parseObjectToQueryString(query)}`);
const getTrip = (trip_id) => get(`/requests/trip/${trip_id}`);
// const getDrive = (drive_id) => get(`/requests/drive/${drive_id}`);
const dispatchDriver = (trip_id, data) => post(`/dispatch/opportunities/${trip_id}/claim`, data);
const updatePayout = (trip_id, amount) => patch(`/dispatch/payout/${trip_id}/bonus`, { amount });
const addOverrideCity = (trip_id, data) => patch(`/dispatch/payout/${trip_id}/addOverrideCity`, data);
const getCities = () => get(`/requests/cities`);
const reinstateRide = (trip_id, ride_id) =>
  post(`/admin/trip/${trip_id}/ride/${ride_id}/reinstate`);
const pickUpRide = (trip_id, data) => post(`/admin/trip/${trip_id}/pickup`, data);
const dropOffRide = (trip_id, data) => post(`/admin/trip/${trip_id}/dropOff`, data);
const updateRideLocation = (trip_id, ride_id, data) =>
  patch(`/admin/trip/${trip_id}/ride/${ride_id}/location`, data);
const transferRide = (ride_id, data) =>
  post(`/admin/ride/${ride_id}/transfer`, data);
const adjustTripDepartureTime = (trip_id, data) =>
  patch(`/admin/trip/${trip_id}/departure-time`, data);

export {
  cancelDriver,
  // getRides,
  getDrives,
  getTrips,
  getTrip,
  // getDrive,
  // updateRidesDrive,
  getRiderHistory,
  getDriverHistory,
  dispatchDriver,
  updatePayout,
  createDriverCancellationEstimate,
  addOverrideCity,
  getCities,
  reinstateRide,
  pickUpRide,
  dropOffRide,
  updateRideLocation,
  transferRide,
  adjustTripDepartureTime,
};
